import { useState } from "react"
import { useDispatch } from "react-redux"
import { Link, useNavigate } from "react-router-dom"
import * as userSlice from "../store/user"
import * as userApis from "../utilities/apis/user"
import Layout from "../components/Layout"

const Login = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    try {
      setLoading(true)
      e.preventDefault()

      const form = new FormData(e.target)
      const username = form.get("username")
      const password = form.get("password")

      if (!username) throw new Error("Username is required")
      if (!password) throw new Error("Password is required")

      const response = await userApis.login({ username, password })
      if (!response.status) throw new Error(response.message)

      dispatch(userSlice.login(response))
      navigate("/dashboard")
    } catch (error) {
      alert(error.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Layout
      header={false}
      footer={false}
    >
      <main className="w-75 mx-auto">
        <div id="login" className="row">
          <div className="col-md-4"></div>
          <div className="col-md-4">
            <div className="card text-dark">
              <div className="card-body">
                <div className="text-center mb-3">
                  <img src="/logo192.png" width={96} />
                </div>
                <div className="text-center mb-5">
                  <h3 className="fw-bold m-0">Phonics</h3>
                  <p className="lead fw-semibold text-body-tertiary m-0">Login to Continue</p>
                </div>

                <form method="POST" onSubmit={handleSubmit}>
                  <div className="form-floating mb-3">
                    <input type="text" name="username" className="form-control" placeholder="Username" required disabled={loading} />
                    <label>Username</label>
                  </div>
                  <div className="form-floating mb-3">
                    <input type="password" name="password" className="form-control" placeholder="Password" required disabled={loading} />
                    <label>Password</label>
                  </div>
                  <div className="text-end mb-3">
                    <Link to="/validate-email">Forgot Password?</Link>
                  </div>
                  <div className="mb-5">
                    <button type="submit" className="btn btn-primary w-100 py-3" disabled={loading}>Login</button>
                  </div>
                  <div className="text-center">
                    <Link to="/register">Don't have an account? Register now</Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="col-md-4"></div>
        </div>
      </main>
    </Layout>
  )
}

export default Login
